// eslint-disable-next-line import/prefer-default-export
export const pb = {
  dashboard: {
    title: "ਡੈਸ਼ਬੋਰਡ",
    no: "ਨਹੀਂ.",
    time: "ਸਮਾਂ",
    patient_info: "ਮਰੀਜ਼ ਜਾਣਕਾਰੀ",
    type: "ਕਿਸਮ",
    urgency: "ਲਾਜ਼ਮੀ",
    assigned_to: "ਨਿਰਧਾਰਤ ਹੈ",
    status: "ਸਥਿਤੀ",
    yrs: "ਸਲੋ",
    yes: "ਹਾਂ",
    new: "ਨਵਾਂ",
    closed: "ਬੰਦ ਹੋ ਗਿਆ",
    escalated: "ਅੱਗੇ ਵਧਿਆ",
    processing: "ਪ੍ਰੋਸੈਸਿੰਗ",
    new_ticket_created: "ਨਵੀਂ ਟਿਕਟ ਉਤਾਰ ਦਿੱਤੀ ਗਈ ਹੈ, ਇਸ ਦੀ ਜਾਂਚ ਕਰੋ !!",
    new_ticket_assignment: "ਨਵੀਂ ਟਿਕਟ ਜਾਰੀ ਕੀਤੀ ਗਈ ਹੈ, ਇਸ ਦੀ ਜਾਂਚ ਕਰੋ !!",
    on_call: "ਕਾਲ 'ਤੇ",
    patient_app: "ਮਰੀਜ਼ ਐਪ",
    all: "ਸਭ",
    filterBy: "ਦੁਆਰਾ ਫਿਲਟਰ",
    typeToSearch: "ਨਾਮ, ਫੋਨਨੰਬਰ, ਟਿਕਟ ਨੰਬਰ ਦੁਆਰਾ ਖੋਜ ਕਰਨ ਲਈ ਟਾਈਪ ਕਰੋ",
    appointment: "ਮੁਲਾਕਾਤ",
    booked: "ਬੁੱਕ ਹੋਇਆ",
    notBooked: "ਬੁੱਕ ਨਹੀਂ ਹੋਇਆ",
    websites: "ਵੈੱਬਸਾਈਟ",
    domains: "ਡੋਮੇਨ",
    searchBy: "ਸੇਰਚ ਕਰੋ:",
    searchByPlaceholder: "ਨਾਮ ਜਾਂ ਫੋਨ ਨੰਬਰ ਨਾਲ ਖੋਜ ਕਰੋ",
    clinicId: "ਕਲੀਨਿਕ ਆਈ.ਡੀ.",
    domainDetail: "ਡੋਮੇਨ ਵੇਰਵੇ",
    viewDetail: "ਵੇਰਵਾ ਵੇਖੋ"
  },
  info_title: "ਜਾਣਕਾਰੀ",
  success_title: "ਸਫਲਤਾ!",
  error_title: "ਗਲਤੀ!",
  domain: {
    dateTime: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ",
    result: "ਨਤੀਜਾ",
    results: "ਨਤੀਜੇ",
    markDone: "ਹੋ ਗਿਆ ਦੇ ਤੌਰ ਤੇ ਮਾਰਕ ਕਰੋ",
    all: "ਸਾਰੇ",
    new: "ਨਵਾਂ",
    done: "ਹੋ ਗਿਆ",
    updateUrl: "ਅਪਡੇਟ ਸਟੇਟਸ",
    confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
    cancel: "ਰੱਦ ਕਰੋ",
    delete: "ਮਿਟਾਓ",
    update: "ਅਪਡੇਟ",
    complete: "ਸੰਪੂਰਨ",
    enterUrl: "Example: https://www.google.com",
    enterValidUrl: "ਵੈਧ url ਦਾਖਲ ਕਰੋ",
    domain: "ਡੋਮੇਨ",
    domainName: "ਡੋਮੇਨ ਨਾਮ",
    status: "ਸਥਿਤੀ",
    filterByType: "ਫਿਲਟਰ ਟਾਈਪ ਅਨੁਸਾਰ:",
    filterByStatus: "ਸਥਿਤੀ ਅਨੁਸਾਰ ਫਿਲਟਰ ਕਰੋ:",
    requestedAt: "ਬੇਨਤੀ ਕੀਤੀ ਗਈ",
    completedAt: "ਪੂਰਾ ਹੋਇਆ"
  },
  website: {
    websiteDetail: "ਕਲੀਨਿਕ ਵੇਰਵਾ",
    clininInfo: "ਜਾਣਕਾਰੀ",
    photos: "ਫੋਟੋਆਂ",
    doctors: "ਡਾਕਟਰ",
    services: "ਸੇਵਾਵਾਂ",
    packages: "ਪੈਕੇਜ",
    reviews: "ਕੁਲਕੇਅਰ ਸਮੀਖਿਆਵਾਂ",
    seo: "ਵੈੱਬਸਾਈਟ ਜਾਣਕਾਰੀ"
  },

  seo: {
    seoTitle: "ਟਾਈਟਲ",
    seoDescription: "ਮੈਟਾ ਵੇਰਵਾ",
    googleCode: "ਗੂਗਲ ਵਿਸ਼ਲੇਸ਼ਣ ਖਾਤਾ ਕੋਡ",
    themeUrl: "ਥੀਮ lਰਲ",
    themeName: "ਥੀਮ ਦਾ ਨਾਮम"
  },
  services: {
    serviceId: "ਆਈ.ਡੀ."
  },
  packages: {
    description: "ਵੇਰਵਾ",
    new_price: "ਨਵੀਂ ਕੀਮਤ",
    valid_till: "ਵੈਧ ਟਿਲ",
    photo: "ਫੋਟੋ",
    old_price: "ਪੁਰਾਣੀ ਕੀਮਤ"
  },
  doctor: {
    name: "ਨਾਮ",
    speciality: "ਵਿਸ਼ੇਸ਼ਤਾ",
    eductaion: "ਸਿੱਖਿਆ",
    experience: "Experience",
    fees: "ਤਜਰਬਾ",
    gender: "ਲਿੰਗ",
    schedule: "ਸਮਾਸੂਚੀ, ਕਾਰਜ - ਕ੍ਰਮ",
    other: "ਹੋਰ",
    photoUrl: "ਫੋਟੋ ਯੂਆਰਐਲ",
    startTime: "ਅਰੰਭ ਟਾਈਮ",
    endTime: "ਅੰਤ ਦਾ ਸਮਾਂ"
  },
  photo: {
    type: "ਟਾਈਪ ਕਰੋ",
    link: "ਲਿੰਕ",
    download: "ਡਾਨਲੋਡ"
  },
  reviews: {
    created: "ਬਣਾਇਆ",
    review: "ਸਮੀਖਿਆ",
    rating: "ਰੇਟਿੰਗ"
  },

  clinic: {
    phone: "ਫੋਨ ਨੰਬਰ",
    email: "ਈਮੇਲ",
    name: "ਨਾਮ",
    area: "ਖੇਤਰ",
    about: "ਬਾਰੇ",
    address: "ਪਤਾ",
    pincode: "ਪਿੰਨਕੋਡ",
    city: "ਸ਼ਹਿਰ",
    speciality: "ਵਿਸ਼ੇਸ਼ਤਾ"
  },
  adminAccess: "ਸਾਈਨ ਇਨ ਕਰਨ ਲਈ ਤੁਹਾਨੂੰ ਪ੍ਰਬੰਧਕ ਦੀ ਪਹੁੰਚ ਦੀ ਲੋੜ ਹੈ",

  connecting_chat: "Connecting to chat",
  connecting_chat_failed: "Connection to chat failed",
  topNav: { sign_out: "Sign out" },
  searchConversations: "ਗੱਲਬਾਤ ਨੂੰ ਲੱਭੋ",
  tickets: {
    add_ticket: "ਟਿਕਟ ਜੋੜੋ",
    patient_name: "ਮਰੀਜ਼ ਦਾ ਨਾਮ",
    error_patient_name: "ਮਰੀਜ਼ ਦਾ ਨਾਮ ਦਿਓ.",
    patient_dob: "ਮਰੀਜ਼ ਦੀ ਜਨਮ ਤਾਰੀਖ",
    gender: "ਲਿੰਗ",
    health_problem: "ਸਿਹਤ ਦੀ ਸਮੱਸਿਆ",
    error_health_problem: "ਸਿਹਤ ਸਮੱਸਿਆ ਪ੍ਰਦਾਨ ਕਰੋ",
    phone_number: "ਫੋਨ ਨੰਬਰ",
    error_phone_number: "ਯੋਗ ਮਰੀਜ਼ ਦਾ ਫੋਨ ਨੰਬਰ ਪ੍ਰਦਾਨ ਕਰੋ",
    location: "ਸਥਾਨ",
    error_location: "ਸਥਾਨ ਮੁਹੱਈਆ ਕ",
    price_from: "ਕੀਮਤ ਰੇਂਜ - ਤੋਂ",
    price_to: "ਕੀਮਤ ਰੇਂਜ - ਅੰਤ",
    error_price_from: "ਸ਼ੁਰੂਆਤ ਮੁੱਲ ਦੀ ਰੇਂਜ ਪ੍ਰਦਾਨ ਕਰੋ",
    error_price_to: "ਅੰਤਮ ਕੀਮਤ ਰੇਂਜ ਮੁਹੱਈਆ ਕਰੋ",
    urgency: "ਲਾਜ਼ਮੀ",
    assigned_to: "ਨਿਰਧਾਰਤ ਹੈ",
    error_assigned_to: "ਨਿਯੁਕਤੀ ਚੁਣੋ",
    close: "ਬੰਦ ਕਰੋ",
    add: "ਜੋੜਨਾ",
    urgent: "ਜ਼ਰੂਰੀ",
    not_urgent: "ਜ਼ਰੂਰੀ ਨਹੀਂ",
    male: "ਮਰਦ",
    female: "ਔਰਤ",
    edit_ticket: "ਟਿਕਟ ਸੰਪਾਦਿਤ ਕਰੋ"
  },
  ticket_detail_view: {
    ticket_details: "ਟਿਕਟ ਵੇਰਵੇ",
    info: "ਜਾਣਕਾਰੀ",
    activity: "ਸਰਗਰਮੀ",
    search: "ਖੋਜ",
    health_problem: "ਸਿਹਤ ਸਮੱਸਿਆ",
    location: "ਸਥਾਨ",
    fee_range: "ਫੀਸ ਰੇਂਜ",
    open_since: "ਕਿੰਨਾ ਟਾਈਮ ਖੂਲੇ ਹੋਇਆ ",
    assigned_to: "ਨਿਰਧਾਰਤ ਹੈ",
    status: "ਸਥਿਤੀ",
    select_agent: "ਏਜੰਟ ਚੁਣੋ",
    select_status: "ਸਥਿਤੀ ਸਥਿਤੀ",
    yrs: "ਸਾਲ",
    edit: "ਸੰਪਾਦਿਤ ਕਰੋ",
    not_signed_up: "ਰਜਿਸਟਰਡ ਨਹੀਂ",
    signed_up: "ਰਜਿਸਟਰਡ ਹੈ",
    previous_tickets: "ਪਿਛਲੀ ਟਿਕਟ",
    fees: "ਫੀਸ",
    select_range: "ਰੇਂਜ ਚੁਣੋ",
    select_speciality: "ਵਿਸ਼ੇਸ਼ਤਾ ਚੁਣੋ",
    speciality: "ਵਿਸ਼ੇਸ਼ਤਾ",
    availability: "ਉਪਲਬਧਤਾ",
    dr_info: "ਡਾਕਟਰ ਦੀ ਜਾਣਕਾਰੀ",
    timings: "ਸਮੇਂ",
    latest_available: "ਤਾਜ਼ਾ ਲਾਹੇਵੰਦ",
    no_data: "ਕੋਈ ਡੇਟਾ ਨਹੀਂ",
    send_to_app: "ਐਪਲੀਕੇਸ਼ਨ ਤੇ ਭੇਜੋ",
    send_sms: "SMS ਭੇਜੋ",
    escalated_to: "ਅੱਗੇ ਵਧਾਇਆ",
    added_note: "ਇੱਕ ਨੋਟ ਸ਼ਾਮਿਲ ਕੀਤਾ",
    add_note: "ਕੋਈ ਨੋਟ ਜੋੜੋ",
    emptyNoteError: "ਸੂਚਨਾ ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦੀ",
    save: "ਸੇਵ ਕਰੋ",
    saveSuccess: "ਟਿਕਟ ਸਫਲਤਾਪੂਰਵਕ ਸੰਭਾਲੀ ਗਈ !!",
    success: "ਸਫਲਤਾ",
    ok: "ਠੀਕ ਹੈ",
    sendMessageSuccess:
      "ਸੰਦੇਸ਼ ਭੇਜਿਆ ਗਿਆ ਹੈ {selectedDoctorNameArr} ਸਫਲਤਾਪੂਰਵਕ!!",
    sendMessageError: "ਸੁਨੇਹਾ ਭੇਜਣ ਲਈ ਇਕ ਡਾਕਟਰ ਦੀ ਚੋਣ ਕਰੋ.",
    selectLocation: "ਸਥਿਤੀ ਚੁਣੋ",
    regularTimings: "ਨਿਯਮਤ ਸਮਾਂ",
    discountedTimings: "ਛੂਟ ਵਾਲਾ ਸਮਾਂ",
    book: "ਬੁੱਕ",
    errorText: "ਤੁਹਾਡੀ ਬੇਨਤੀ ਦੀ ਪ੍ਰਕ੍ਰਿਆ ਕਰਦੇ ਸਮੇਂ ਕੁਝ ਸਮੱਸਿਆ ਸੀ.",
    bookingSuccess: "ਮੁਲਾਕਾਤ ਸਫਲਤਾਪੂਰਵਕ ਕੀਤੀ ਗਈ",
    bookAppointment: "ਬੁਕ ਨਿਯੁਕਤੀ",
    bookAppointmentConfirmText:
      "ਕੀ ਤੁਸੀਂ ਨਿਸ਼ਚਤ ਰੂਪ ਤੋਂ ਇਸ ਸਲਾਟ ਵਿੱਚ ਮੁਲਾਕਾਤ ਨੂੰ ਬੁੱਕ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    bookAppointmentText:
      "ਨਾਲ ਨਿਯਮਤ ਨਿਯੁਕਤੀ ਬੁੱਕ ਕੀਤੀ {doctorName} ਇਸ ਦਿਨ ਲਇ {appointmentDate}",
    bookDiscountedAppointmentText:
      "ਨਾਲ ਛੋਟ ਵਾਲੀ ਮੁਲਾਕਾਤ ਬੁੱਕ ਕੀਤੀ ਗਈ {doctorName} ਇਸ ਦਿਨ ਲਇ {appointmentDate} ਇਸ ਟਾਈਮ ਲਇ {startTime} - {endTime}",
    reBookAppointmentText:
      "ਨਾਲ ਨਿਯਮਤ ਨਿਯੁਕਤੀ ਦੁਬਾਰਾ ਨਿਰਧਾਰਤ ਕੀਤੀ {doctorName} ਇਸ ਦਿਨ ਲਇ {appointmentDate}",
    reBookDiscountedAppointmentText:
      "ਦੇ ਨਾਲ ਇਕ ਛੋਟੀ ਮੁਲਾਕਾਤ ਮੁੜ-ਬੁੱਕ ਕੀਤੀ ਗਈ {doctorName} ਇਸ ਦਿਨ ਲਇ {appointmentDate} ਇਸ ਟਾਈਮ ਲਇ {startTime} - {endTime}",
    dr: "Dr.",
    changesStatus: "ਸਥਿਤੀ ਨੂੰ ਤਬਦੀਲ ਕਰਨ ਲਈ",
    date: "ਤਾਰੀਖ:",
    TimeSlot: "ਟਾਈਮ ਸਲਾਟ:",
    BookedOn: "ਬੁਕਡ ਐਨ:",
    doctor: "ਡਾਕਟਰ:",
    Contact: "ਸੰਪਰਕ ਕਰੋ:",
    Clinic: "ਕਲੀਨਿਕ:",
    AppointmentDetails: "ਮੁਲਾਕਾਤ ਵੇਰਵੇ",
    unverifyTitle: "ਕੀ ਤੁਸੀਂ ਡਾਕਟਰ ਨੂੰ ਵੈਰਿਫਾਇ ਚਾਹੁੰਦੇ ਹੋ?",
    VerifyDoctor: "ਵੈਰਿਫਾਇ ਡਾਕਟਰ",
    UnverifyDoctor: "ਅਨਵੈਰਿਫਾਇ ਡਾਕਟਰ",
    verifyReason: "ਡਾਕਟਰ ਵੈਰਿਫਾਇ ਕਾਰਨ ਕੀ ਹੈ",
    unverifyReason: "ਕੀ ਤੁਸੀਂ ਚਾਹੋਗੇ ਅਨਵੈਰਿਫਾਇ ਡਾਕਟਰ",
    MedicalLicense: "ਮੈਡੀਕਲ ਲਾਇਸੈਂਸ",
    ClickToView: "ਦੇਖਣ ਲਈ ਕਲਿੱਕ ਕਰੋ",
    VerifyStatus: "ਵੈਰਿਫਾਇ ਸਥਿਤੀ",
    VerifiedBy: "ਵੈਰਿਫਾਇ ਨਾਲ",
    VerifiedAt: "ਵੈਰਿਫਾਇ ਤੇ",
    VerifyReason: "ਵੈਰਿਫਾਇ ਕਾਰਨ",
    chat: "ਚੈਟ ਕਰੋ"
  },
  page_not_found: {
    pageNotFound: "ਪੰਨਾ ਮਿਲਿਆ ਨਹੀਂ"
  },
  referrals: {
    referralsText: "ਰੈਫਰਲ",
    referredTo: "ਰੈਫਰਡ ਤੂ",
    referredBy: "ਰੈਫਰਡ ਬਾਈ",
    appointmentStatus: "ਸਥਿਤੀ",
    addToQueue: "ਕਤਾਰ ਵਿੱਚ ਜੋੜੋ",
    viewNotes: "ਨੋਟ ਵੇਖੋ",
    selectDateForAppt: "ਨਿਯੁਕਤੀ ਦੀ ਮਿਤੀ ਦੀ ਚੋਣ ਕਰੋ",
    referralNotes: "ਰੈਫਰਲ ਨੋਟਸ",
    noReferralNotes: "ਡਾਕਟਰ ਕੇ ਕੋਈ ਰੈਫਰਲ ਨੋਟਸ ਦਰਜ ਨਹੀਂ ਹੈ",
    newReferralRecieved: "ਨਯਾ ਰੈਫਰਲ ਮਿਲਾ",
    serialNo: "S.no",
    patient: "ਮਰੀਜ਼"
  },
  year: "ਸਾਲ",
  month: "ਮਹੀਨਾ",
  schedule: {
    updateSchedule: "ਅਪਡੇਟ ਅਨੁਸੂਚੀ",
    addSchedule: "ਅਨੁਸੂਚੀ ਜੋੜੋ",
    daily: "ਰੋਜ਼ਾਨਾ",
    mon: "ਸੋਮ",
    tue: "ਮੰਗਲ",
    wed: "ਬੁੱਧ",
    thu: "ਵੀਰ",
    fri: "ਸ਼ੁੱਕਰ",
    sat: "ਸ਼ਨੀ",
    sun: "ਐਤ",
    startTime: "ਸ਼ੁਰੂਆਤੀ ਸਮਾਂ",
    closingTime: "ਸਮਾਪਤੀ ਸਮਾਂ",
    discounted_schedule: "ਛੂਟ ਵਾਲਾ ਸਮਾਂ",
    regular_schedule: "ਨਿਯਮਤ ਸਮਾਂ",
    fees: "ਫੀਸ",
    cancel: "ਰੱਦ ਕਰੋ",
    emptyDays: "ਦਿਨ ਚੁਣੋ ਜੀ",
    emptyTimings: "ਕਿਰਪਾ ਕਰਕੇ ਸਮੇਂ ਦੀ ਚੋਣ ਕਰੋ",
    invalidTiming: "ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਸਮਾਂ ਚੁਣੋ",
    emptyFeesError: "ਕਿਰਪਾ ਕਰਕੇ ਫ਼ੀਸ ਦੀ ਰਕਮ ਦਾਖ਼ਲ ਕਰੋ",
    scheduleInfo: "ਅਨੁਸੂਚੀ ਦੀ ਜਾਣਕਾਰੀ",
    scheduleText: "ਅਨੁਸੂਚੀ",
    addedSuccess: "ਨੂੰ ਸਫਲਤਾ ਨਾਲ ਸ਼ਾਮਿਲ ਕੀਤਾ ਗਿਆ ਹੈ",
    serverError: "ਤੁਹਾਡੀ ਬੇਨਤੀ ਦੀ ਪ੍ਰਕ੍ਰਿਆ ਕਰਦੇ ਸਮੇਂ ਕੁਝ ਅਸ਼ੁੱਧੀ ਹੋਈ ਸੀ",
    remove: "ਹਟਾਓ",
    removed: "ਸਫਲਤਾਪੂਰਵਕ ਹਟਾ ਦਿੱਤਾ ਗਿਆ",
    days: "ਦੀਨ",
    timings: "ਸਮੇਂ",
    removeScheduleConfirmText:
      "ਕੀ ਤੁਸੀਂ ਨਿਸ਼ਚਤ ਰੂਪ ਨਾਲ ਇਸ ਅਨੁਸੂਚੀ ਨੂੰ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    updateDoctor: "ਡਾਕਟਰ ਦੀ ਜਾਣਕਾਰੀ ਅਪਡੇਟ ਕਰੋ",
    updateDoctorSuccess: "ਡਾਕਟਰ ਦੀ ਜਾਣਕਾਰੀ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਕੀਤੀ ਗਈ",
    updateFees: "ਅਪਡੇਟ ਫੀਸ",
    Next: "Next",
    edit: "Edit",
    delete: "Delete",
    save: "Save"
  },
  profile: {
    clinicName: "ਕਲੀਨਿਕ ਦਾ ਨਾਂ",
    emptyText: "ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦਾ",
    addressText: "ਐਡਰੈੱਸ",
    zipcode: "ਪਿੰਨਕੋਡ",
    city: "ਸ਼ਹਿਰ",
    selectLocationError: "ਕਿਰਪਾ ਕਰਕੇ ਡ੍ਰੌਪਡਾਉਨ ਤੋਂ ਸ਼ਹਿਰ ਦੀ ਚੋਣ ਕਰੋ",
    SearchPlaces: "ਸਥਾਨਾਂ ਦੀ ਖੋਜ ਕਰੋ",
    state: "ਰਾਜ",
    basicInfoSaveSuccess: "ਪ੍ਰੋਫਾਈਲ ਦੀ ਜਾਣਕਾਰੀ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਕੀਤੀ ਗਈ",
    doctorName: "ਡਾਕਟਰ ਦਾ ਨਾਂ",
    isRequired: "ਜਰੂਰੀ ਹੈ",
    dateOfBirth: "ਜਨਮ ਤਾਰੀਖ",
    registrationNumber: "ਰਜਿਸਟਰੇਸ਼ਨ ਨੰਬਰ",
    patientsPerHour: "ਮਰੀਜ਼/ ਘੰਟਾ",
    experience: "ਅਨੁਭਵ (ਸਾਲ)",
    bio: "ਬਾਇਓ",
    next: "ਅਗਲਾ",
    updateEducationSuccess: "ਸਿੱਖਿਆ ਦੀ ਜਾਣਕਾਰੀ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਕੀਤੀ ਗਈ",
    error: "ਏਰਰ",
    educationExists: "ਸਿੱਖਿਆ ਪਹਿਲਾ ਤੋਂ ਮਜੂਦ ਹੈ",
    deleteEducationSuccess: "ਸਿੱਖਿਆ ਦੀ ਜਾਣਕਾਰੀ ਸਫਲਤਾਪੂਰਵਕ ਹਟਾ ਦਿਤੀ ਗਈ ਹੈ",
    educationName: "ਸਿੱਖਿਆ ਦਾ ਨਾਂ",
    action: "ਐਕਸ਼ਨ",
    clinicProfile: "ਕਲੀਨਿਕ ਪ੍ਰੋਫਾਈਲ",
    clinicSaveSuccess: "ਕਲੀਨਿਕ ਪ੍ਰੋਫਾਈਲ ਦੀ ਜਾਣਕਾਰੀ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਕੀਤੀ ਗਈ",
    doctors: "ਡਾਕਟਰ"
  },
  ticket: { created_ticket: "created ticket" },
  signin: {
    signInHeadingText: "Please sign in with your phone number and password",
    enterPhoneNumber: "Please enter phone number",
    passwordRequired: "Please enter the password.",
    password: "Password",
    signInText: "Sign in"
  },
  typeToSeachByName: "Type name press enter",
  searchByName: "Search by name",
  radiusPlaceholder: "ਰੇਡੀਅਸ",
  radius: "ਰੇਡੀਅਸ (ਕਿ.ਮੀ. ਵਿੱਚ)",
  go_home: "ਗੋ ਹੋਮ"
};
